import styled from 'styled-components';
import { Colors } from '../../../theme';
export const InfoSection = styled.section `
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  border-bottom: solid 1px ${Colors.black40};
`;
export const MenuSection = styled.section `
  box-sizing: border-box;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 4px 0;
  border-bottom: solid 1px ${Colors.black40};
`;
export const Wrapper = styled.div `
  display: block;
  width: 100%;
`;
//# sourceMappingURL=styles.js.map